import { Box, CircularProgress } from '@mui/material'
import { useDispatch, useSelector } from 'react-redux'
import { RootState } from '../../store'
import { useEffect, useMemo } from 'react'
import {
  fetchAllCodeValidationRules,
  getValidationStatus,
} from '../../services/validationService'
import CodeValidationSummaryContainer from './CodeValidationSummaryContainer'
import ValidationIssuesClusterComponent from './ValidationIssuesClusterComponent'
import {
  CodeDetail,
  CodeValidationDiscipline,
  CodeValidationStatus,
} from '../../models/Validation'

const ValidationTab = () => {
  const dispatch = useDispatch<any>()

  const isCodeValidationResultSelected = Boolean(
    useSelector(
      (state: RootState) => state.validation.selectedCodeValidationRule,
    ),
  )

  const isCodeValidationStatusChecking = Boolean(
    useSelector(
      (state: RootState) => state.validation.isCodeValidationStatusChecking,
    ),
  )

  const isValidationTaskExists = Boolean(
    useSelector((state: RootState) => state.validation.currentValidationTask),
  )

  const codeValidationRules = useSelector(
    (state: RootState) => state.validation.codeValidationRules,
  )

  const allCodes = useMemo(
    () =>
      [
        ...codeValidationRules.architectural,
        ...codeValidationRules.structural,
        ...codeValidationRules.mep,
        ...codeValidationRules.other,
      ].map((rule) => ({
        description: rule.description,
        codeReference: rule.codeReference,
        codeId: rule.id,
        atomics: rule.atomics,
        elementIds: rule.elementsIds || [],
        elements: rule.elements || [],
        status: rule.status || CodeValidationStatus.Failed,
        conflict: 'Code Conflicts' as const,
        discipline: rule.discipline || CodeValidationDiscipline.Other,
      })),
    [codeValidationRules],
  )

  console.log('allCodes', allCodes)

  const codeGroups = useMemo(
    () =>
      Object.entries(
        allCodes.reduce(
          (acc, code) => {
            const group = code.codeReference
            if (!acc[group]) acc[group] = []
            acc[group].push(code)
            return acc
          },
          {} as Record<string, CodeDetail[]>,
        ),
      ).map(([groupName, codes]) => ({ groupName, codes })),
    [allCodes],
  )

  console.log(
    'isCodeValidationStatusChecking',
    isCodeValidationStatusChecking,
    codeGroups,
    isCodeValidationStatusChecking || !(codeGroups.length > 0),
  )
  console.log('isValidationTaskExists', isValidationTaskExists)
  useEffect(() => {
    dispatch(
      getValidationStatus({
        autoCreateTaskIfMissing: false,
      }),
    )
  }, [dispatch])

  useEffect(() => {
    if (isValidationTaskExists) {
      const abortController = new AbortController()

      dispatch(fetchAllCodeValidationRules({ signal: abortController.signal }))

      return () => {
        abortController.abort()
      }
    }
  }, [isValidationTaskExists])

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
      }}
    >
      {isCodeValidationStatusChecking || !(codeGroups.length > 0) ? (
        <Box
          sx={{
            width: '400px',
            height: '100%',
            display: 'flex',
            borderRadius: '2px',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <CircularProgress />
        </Box>
      ) : isValidationTaskExists ? (
        <>
          <Box
            sx={{
              width: '460px',
              height: '100%',
              display: 'flex',
              borderRadius: '2px',
              flexDirection: 'column',
            }}
          >
            <Box
              sx={{
                flexGrow: 1,
                padding: '6px 12px 12px',
                height: '100%',
                borderBottomLeftRadius: '2px',
                borderBottomRightRadius: isCodeValidationResultSelected
                  ? '0px'
                  : '2px',
              }}
            >
              <CodeValidationSummaryContainer codeGroups={codeGroups} />
              <ValidationIssuesClusterComponent />
            </Box>
          </Box>
        </>
      ) : null}
    </Box>
  )
}

export default ValidationTab
